'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024$0024anon$002443 from "./presto.types$-Credential-Hash$$anon$43.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialHash$() {
  this.c4q = null;
  this.c4r = false;
  this.c4o = null;
  this.c4p = false;
  this.c4s = null;
  this.c4t = false;
  this.c4u = null;
  this.c4v = false;
}
export { $c_Lpresto_types$CredentialHash$ as $c_Lpresto_types$CredentialHash$ };
$p = $c_Lpresto_types$CredentialHash$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialHash$;
/** @constructor */
function $h_Lpresto_types$CredentialHash$() {
}
export { $h_Lpresto_types$CredentialHash$ as $h_Lpresto_types$CredentialHash$ };
$h_Lpresto_types$CredentialHash$.prototype = $p;
$p.gJ = (function() {
  if ((!this.c4r)) {
    this.c4q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c4r = true;
  }
  return this.c4q;
});
$p.ep = (function() {
  if ((!this.c4p)) {
    this.c4o = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c4p = true;
  }
  return this.c4o;
});
$p.cIE = (function() {
  if ((!this.c4t)) {
    this.c4s = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c4t = true;
  }
  return this.c4s;
});
$p.adH = (function() {
  if ((!this.c4v)) {
    this.c4u = new $j_presto$002etypes$0024$002dCredential$002dHash$0024$0024anon$002443.$c_Lpresto_types$CredentialHash$$anon$43(this);
    this.c4v = true;
  }
  return this.c4u;
});
var $d_Lpresto_types$CredentialHash$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialHash$, "presto.types$CredentialHash$", ({
  YN: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialHash$ as $d_Lpresto_types$CredentialHash$ };
var $n_Lpresto_types$CredentialHash$;
function $m_Lpresto_types$CredentialHash$() {
  if ((!$n_Lpresto_types$CredentialHash$)) {
    $n_Lpresto_types$CredentialHash$ = new $c_Lpresto_types$CredentialHash$();
  }
  return $n_Lpresto_types$CredentialHash$;
}
export { $m_Lpresto_types$CredentialHash$ as $m_Lpresto_types$CredentialHash$ };
//# sourceMappingURL=presto.types$-Credential-Hash$.js.map
